import { useCallback, useEffect } from 'react';
import axios from 'axios';
import { useAsync } from 'react-async-hook';
import { useAuth } from 'hooks/useAuth';

type Version = {
  version: string;
};

const isBuildNew = (versionA: string, versionB: string) => {
  const versionsA = versionA.split(/\./g);
  const versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());
    const b = Number(versionsB.shift());
    if (a !== b) {
      return a > b || Number.isNaN(b);
    }
  }

  return false;
};

export const CacheBuster = ({ children }: any) => {
  const { logout } = useAuth();

  const deleteLocalStorageAndReload = useCallback(() => {
    if (caches) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }
    localStorage.clear();
    sessionStorage.clear();
    logout();
  }, [logout]);

  const metaData = useAsync(() => axios.get<Version>(`/meta.json`), []);

  useEffect(() => {
    if (metaData.result?.data) {
      const latestVersionDate = metaData.result?.data.version;
      const clientVersionDate = localStorage.getItem('clientVersionDate');
      const shouldForceRefresh = isBuildNew(latestVersionDate, clientVersionDate || '');

      if (!clientVersionDate) {
        localStorage.setItem('clientVersionDate', latestVersionDate);
      }

      if (shouldForceRefresh) {
        deleteLocalStorageAndReload();
        localStorage.setItem('clientVersionDate', latestVersionDate);
      }
    }
  }, [deleteLocalStorageAndReload, metaData]);

  return children || null;
};
